import type { ReactNode } from 'react';

export const symbol_format_letter_spacing_standard: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M168.5-168.63Q160-177.25 160-190v-580q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v580q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Zm580 0Q740-177.25 740-190v-580q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v580q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM339-284q-11.03 0-17.51-9.5Q315-303 319-314l131-353q2-7 8-11t13.1-4h16.8q7.1 0 13.1 4t8 11l132 353q4 11-2 20.5t-18.36 9.5q-8 0-13.82-4T599-299l-33-96H394l-34 97q-2.17 6.67-7.97 10.33Q346.24-284 339-284Zm70-151h142l-70-196h-2l-70 196Z"
		/>
	</svg>
);
